export default __webpack_public_path__ + "static/media/blog-post-layout-03-img-02.c2789fb8.jpg";